<template>
    <div ref="container">
        <div class="box">
            <div class="jumbo">
                <slideshow @init="imageCount++" @loaded="thumbLoaded()"/>
            </div>
        </div>

        <div v-for="chunk in chunks">
            <div layout="row sm-column top-stretch">
                <div layout="row top-stretch">
                    <div v-for="project in chunk[0]">
                        <thumbnail v-bind="project" @init="imageCount++" @loaded="thumbLoaded()"/>
                    </div>
                </div>
                <div layout="row top-stretch">
                    <div v-for="project in chunk[1]">
                        <thumbnail v-bind="project" @init="imageCount++" @loaded="thumbLoaded()"/>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

    import Thumbnail from '@/components/Thumbnail';
    import AppSettings from '@/AppSettings';
    import Lightbox from "@/components/Lightbox";
    import SwfPlayer from "@/components/SwfPlayer";
    import LightBoxLink from "@/components/LightboxLink";
    import TheFooter from "@/components/TheFooter";
    import Slideshow from "../components/Slideshow";


    export default {
        components: {
            Slideshow,
            TheFooter,
            LightBoxLink,
            SwfPlayer,
            Lightbox,
            Thumbnail
        },
        name: "home",
        data() {
            return {
                chunks: [],
                lb: true,
                interval: null,
                imageCount: 0
            }
        },
        methods: {
            thumbLoaded() {
                this.imageCount--;
                if (this.imageCount == 0) {
                    this.$preloader.hide();
                }
            }
        },
        mounted() {
            this.chunks = AppSettings.instance.chunks;
            // console.log(AppSettings.instance.savedScrollPosition);
            /*let pageYOffset = window.pageYOffset;

            TweenLite.to(this.$refs.container, 5, {scaleY: 2});

            this.interval = setInterval(() => {
              const speed = Math.abs(window.pageYOffset - pageYOffset) * 0.001 + 1;
              pageYOffset = window.pageYOffset;
              this.scale = speed;

              // if (speed > 1) {
              const origin = (pageYOffset + window.innerHeight * 0.5) * 100 / this.$refs.container.clientHeight;
              TweenLite.to(this.$refs.container, 0.5, {scaleY: speed});
              this.$refs.container.style.transformOrigin = `0% ${origin}%`;
              // console.log(pageYOffset, this.$refs.container.clientHeight, origin);
              // }


            }, 33);*/

        },
        destroyed() {
            // clearInterval(this.interval);
        }
    }
</script>

<style lang="scss" scoped>
    .shadow {
        /*box-shadow: 0 0 20px rgba(0, 0, 0, 0.2)  ;
        -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2)  ;
        -moz-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2)  ;*/
        /*filter: drop-shadow(0 0 10px rgba(0,0,0, 0.2));*/
    }

    /*.stretch {*/
    /*transform-origin: 0% 50%;*/
    /*transform: scale3d(1,1.5,1);*/
    /*}*/


</style>
